import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=f9703520&scoped=true&"
import script from "./BlogDetails.vue?vue&type=script&lang=js&"
export * from "./BlogDetails.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=f9703520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9703520",
  null
  
)

export default component.exports